module.exports = __webpack_public_path__ + "img/desc3.ce2e5b7b.png";